import React, { createContext, useMemo, useState } from "react";



export interface IOrgSettingsContext {
    appId: string,
    setAppId: (workspaceId: string) => void,
    workspaceName: string,
    setWorkspaceName: (workspaceName: string) => void,
    orgId: string,
    setOrgId: (orgId: string) => void,
    userId: string,
    setUserId: (userId: string) => void
}

const orgSettingsDefaults:IOrgSettingsContext = {
    appId: undefined,
    workspaceName: undefined,
    orgId: undefined,
    userId: undefined,
    setOrgId: () => {},
    setAppId :() => {},
    setWorkspaceName:() => {},
    setUserId:() => {}
}

export const OrgSettingsContext = createContext(orgSettingsDefaults);

const OrgSettingsProvider = ({children}:{children:React.ReactNode}) => {
    const [appId, setAppId] = useState<string>("");
    const [orgId, setOrgId] = useState<string>("");
    const [workspaceName, setWorkspaceName] = useState<string>("");
    const [userId, setUserId] = useState<string>("");

    const context = useMemo(() => (
      {appId, setAppId, workspaceName, setWorkspaceName, orgId, setOrgId, userId, setUserId}
    ), [appId, workspaceName, orgId, userId])
    
    return (
      <OrgSettingsContext.Provider value={context}>
        {children}
      </OrgSettingsContext.Provider>
    );
};

export default OrgSettingsProvider;
